export default "__VITE_ASSET__CZqU$WSH__"